import { useCallback, useMemo, useState } from 'react';
import { createHookContext } from '@clover-util/react-context';
import { OrderReceipt } from 'olo-service';
import { usePostConversionTracking } from 'hooks/useApi/usePostConversionTracking';

export const { OrderResponseSummaryProvider, useOrderResponseSummary } = createHookContext(
  'OrderResponseSummary',
  () => {
    const [orderResponse, setOrderResponse] = useState<OrderReceipt>();
    const [conversionTrackingResponse, setConversionTrackingResponse] = useState<OrderReceipt>();
    const value = useMemo(() => ({
      orderResponse,
      setOrderResponse,
      setConversionTrackingResponse,
      conversionTrackingResponse,
    }),[
      orderResponse,
      setOrderResponse,
      setConversionTrackingResponse,
      conversionTrackingResponse,
    ]);

    return {
      ...value
    };
  }
);
